import React, {useContext, useEffect, useState} from 'react'
import {RecipeConText} from "../../../../../context/RecipeContext";

const RecipeItemTotal = ({rowId}) => {

    const {rowData} = useContext(RecipeConText)
    const [rowState] = rowData
    const [totalPrice, setTotalPrice] = useState(0)

    useEffect(() => {
      if(rowState[rowId].data){
          let totalAmount = rowState[rowId].data.price * rowState[rowId].quantity * rowState[rowId].parity
          setTotalPrice(totalAmount)
      }
    })

    return(
        <React.Fragment>
            <span>{new Intl.NumberFormat().format(totalPrice)}</span>
        </React.Fragment>
    )
}
export default RecipeItemTotal